module.exports = __webpack_public_path__ + "img/email-confirmed.494228de.svg";